import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useDetails from "src/hooks/useDetails";
import axios from "axios";

// const ROLES = {
//   Care_Admin_Manager: "84825",
//   Care_Admin: "23582",
//   Patient: "78484",
//   Patient_Guardian: "60281",
//   Insurance: "08364",
//   Doctor: "13735",
// };

const Protected = () => {
  const details = useDetails();
  const location = useLocation();

  const requestPagesUrls = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_KAIZEN_API}/api/dev1/2222/permission`,
        { id: details?.roles[0] }
      );
      console.log("permission", typeof response?.data);
      if (details?.rolesname[0] !== "Provider") {
        console.log(details);
        let permission = response?.data;
        // permission.push("chat");
        // permission.push("tbi");
        // permission.push("headache-cdss");
        console.log("permission", permission);
        return permission;
      } else {
        let permission = response?.data.slice(1, -1);
        permission = permission
          .split(",")
          .map((item) => item.replace(/^"|"$/g, ""));
        // permission.push("chat");
        // permission.push("tbi");
        // permission.push("headache-cdss");
        sessionStorage.setItem("permission", JSON.stringify(permission));
        return permission;
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (details?.token) {
      requestPagesUrls().then((res) => {
        const localData = JSON.parse(sessionStorage.getItem("user"));
        localData.permission = res;
        Object.keys(details?.apiData).length && details?.setApiData(localData);
        sessionStorage.setItem("user", JSON.stringify(localData));
      });
    }
  }, []);

  return details?.token ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};
export default Protected;
